import React from "react";
import AutomationChat from "./AutomationChat";

const Automation = () => {
  return (
    <div>
      <AutomationChat />
    </div>
  );
};

export default Automation;
